export const reverseNumber = value => value
	.split("")
	.reverse()
	.join("");

export const getRegExp = symbol => {
	let sym = symbol;
	switch (symbol) {
	case ".":
		sym = "\\.";
		break;
	case ",":
		sym = ",";
		break;
	case " ":
		sym = "\\s";
		break;
	case "'":
		sym = "'";
		break;
	default:
		sym = symbol;
		break;
	}

	return sym;
};

export const getNumberFormat = (format, lang) => {
	let numberFormat = format;
	if (numberFormat === "auto") {
		try {
			// use formatToParts to get the lang numberFormat
			const parts = new Intl.NumberFormat(lang.replace("_", "-")).formatToParts(10000.1);
			numberFormat = parts.reduce((obj, p) => {
				if (p.type === "group" || p.type === "decimal") {
					obj.push(p.value);
				}

				return obj;
			}, []);
		} catch (error) {
			return undefined;
		}
	}
	if (numberFormat === "(space),") {
		return {
			thousand: " ",
			decimal: ","
		};
	}
	if (!numberFormat || numberFormat.length !== 2) {
		return undefined;
	}

	return {
		thousand: numberFormat[0],
		decimal: numberFormat[1]
	};
};

export const formatNumber = (config, lang) => {
	let value = config.expression;
	if (!config.extraSettings.decimalValue || isNaN(value)) {
		return value;
	}

	const hasDecimal = String(value).includes(".");
	const fractionSize = config.extraSettings?.fractionSize ?? 0;
	const decimalPart = value.toString().split(".")[1];
	const decimalPartLength = decimalPart?.length;

	value = decimalPartLength && fractionSize && decimalPartLength > fractionSize
		? parseFloat(value).toFixed(fractionSize)
		: value;

	let stringValue = Object.is(value, -0) ? "-0" : value.toString();
	stringValue = stringValue.replace(/^(-?)0+(?=\d)/, "$1");

	const format = getNumberFormat(config.extraSettings.numberFormat, lang);

	if(!format) {
		return stringValue;
	}


	const rgxSep = new RegExp("(.+)" + getRegExp(format.thousand) + "$");


	// extra case for other decimal delimiter (not a dot), we must replace that by format.decimal from the conf
	if (hasDecimal && format.decimal !== ".") {
		const lastDotIndex = stringValue.lastIndexOf(".");
		const part1 = stringValue.slice(0, lastDotIndex);
		const part2 = lastDotIndex === stringValue.length - 1 ? "" : stringValue.slice(lastDotIndex + 1);
		stringValue = `${part1}${format.decimal}${part2}`;
	}

	// Split by format.decimal
	const numSplitted = stringValue.toString().split(format.decimal);

	// Apply thousands delimiters
	const intFormatReversed = reverseNumber(numSplitted[0])
		.replace(/(\d{3})(?=\d)/g, "$1" + format.thousand)
		.replace(rgxSep, "$1");
	const intFormatted = reverseNumber(intFormatReversed);

	let floated = numSplitted[1] || "";
	floated = floated.padEnd(fractionSize, "0");

	return intFormatted.concat(floated !== "" ? format.decimal + floated : "");
};